import Material from './Material';
import Vue from 'vue';
const defaults = {
    count: 1,
    contentType:"image"
};
let MaterialInstance;
function getMaterialInstance (count=defaults.count,contentType=defaults.contentType,onOk,onCancel) {
        const _props =  {
            opt_limit: count,
            contentType:contentType,
            onOk:onOk
        };
        const Instance = new Vue({
            render (h) {
                return h(Material, {
                    props: _props
                });
            }
        });
        const component = Instance.$mount();
        document.body.appendChild(component.$el);
        const notification = Instance.$children[0];
       // notification.$parent.onOk = _props.onOk;
        //notification.$parent.onCancel = _props.onCancel;
        return {
            destroy () {
                notification.close()
            }
        };
}


export default {
    name: 'Material',
    showImg (options) {
        
        this.MaterialInstance=getMaterialInstance(options.count,options.contentType,options.onOk,options.onCancel);

        return MaterialInstance;
    },
    close () {
        this.MaterialInstance.destroy()
    }
};


// WEBPACK FOOTER //
// ./src/components/Material/index.js